import api from "../config/api";

export const getLocations = async (data) => {
  const res = await api.post("location", data);
  return res.data;
};

export const getLocationByid = async (_id) => {
  const res = await api.get(`location/${_id}`);
  return res.data;
};
